import React from 'react'
import {Document, Page, View, Text, StyleSheet} from '@react-pdf/renderer'
import { dateMountString } from '../../../assets/js/helper'

type Props = {
    athletes: any[]
    club: any
    startDate?: string
}

function limparTexto(valor:string):string {
    return valor.replace(/[.,/-]/g, '');
}

const B = 0.5
const BC = '#000'
const widthA = "7%";

const styles = StyleSheet.create({
    page: {
        paddingBottom: 40,
        paddingTop: 19,
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: 8,
        flexDirection: 'column',
    },

    // Wrapper da tabela: apenas agrupa as linhas, sem bordas
    tableWrapper: {},

    row: {
        flexDirection: 'row',
    },

    cell: {
        padding: 4,
        justifyContent: 'center',
        borderRightWidth: B,
        borderRightColor: BC,
        borderBottomWidth: B,
        borderBottomColor: BC,
        borderTopWidth: B,
        borderTopColor: BC,
        borderLeftWidth: B,
        borderLeftColor: BC,
    },

    headerYellow: {
        backgroundColor: '#FFFF00',
    },

    headerGray: {
        backgroundColor: '#D9D9D9',
    },

    colA1: {
        width: widthA,
        padding: 4,
        justifyContent: 'center',

        borderTopWidth: B,
        borderTopColor: BC,

        borderLeftWidth: B,
        borderLeftColor: BC,

        borderRightWidth: B,
        borderRightColor: BC,

        borderBottomWidth: 0,
    },

    colA2: {
        width: widthA,
        padding: 4,
        justifyContent: 'center',

        borderLeftWidth: B,
        borderLeftColor: BC,

        borderRightWidth: B,
        borderRightColor: BC,

        borderBottomWidth: B,
        borderBottomColor: BC,

        borderTopWidth: 0,
    },

    colA: { width: widthA },
    colB: { width: '26%' },
    colC: { width: '22%' },
    colD: { width: '16%' },
    colE: { width: '16%' },
    colF: { width: '18%' },

    colBC: { width: '48%' },
    colDE: { width: '32%' },

    footerText: {
        marginTop: 5,
        fontSize: 7,
        textAlign: 'center',
        fontWeight: 'bold',
    },

    signature: {
        marginTop: 20,
        textAlign: 'center',
    },
})

export default function MembershipReportPDF({ athletes, club, startDate }: Props) {
    const now = new Date()

    const refDate = startDate ? new Date(startDate) : now
    const monthName = refDate.toLocaleString('pt-BR', { month: 'long' }).toUpperCase()
    const year = refDate.getFullYear()

    const clubAddress = club?.address
        ? `${club.address.street}, ${club.address.number}, ${club.address.district} - ${club.address.city?.name}/${club.address.city?.state?.abbreviation}`
        : ''

    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page} wrap>
                <View style={styles.tableWrapper}>
                    <View style={styles.row} wrap={false}>
                        <View style={[styles.cell, { width: '100%',textAlign: 'center',fontWeight: 'bold' }, styles.headerYellow]}>
                            <Text>
                                RELAÇÃO DOS ATIRADORES E DOS ATLETAS QUE FREQUENTARAM ESTA ENTIDADE DE TIRO DESPORTIVO NO MÊS DE {monthName} DE {year}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.row} wrap={false}>
                        <View style={[styles.colA1, { textAlign: 'center'}, styles.headerYellow]}>
                            <Text>ORD NUMÉRICA</Text>
                        </View>
                        <View style={[styles.cell, styles.colB, styles.headerYellow]}>
                            <Text>Nome da entidade de tiro: {club?.fantasia}</Text>
                        </View>
                        <View style={[styles.cell, styles.colC, styles.headerYellow]}>
                            <Text>CR da entidade Tiro:{limparTexto(club?.cr_number)}{'\n'}CNPJ: {limparTexto(club?.cnpj)}</Text>
                        </View>
                        <View style={[styles.cell, styles.colDE, styles.headerYellow]}>
                            <Text>Endereço da entidade de tiro: {clubAddress}</Text>
                        </View>
                        <View style={[styles.cell, styles.colF, styles.headerYellow]}>
                            <Text>SFPC de vinculação: 3° RM</Text>
                        </View>
                    </View>

                    <View style={styles.row} wrap={false}>
                        <View style={[ styles.colA2, styles.headerYellow]}>
                            <Text />
                        </View>
                        <View style={[styles.cell, styles.colBC, styles.headerGray]}>
                            <Text>Nome Completo do atirador/atleta</Text>
                        </View>
                        <View style={[styles.cell, styles.colD, styles.headerGray]}>
                            <Text>CR atirador/atleta</Text>
                        </View>
                        <View style={[styles.cell, styles.colE, styles.headerGray]}>
                            <Text>CPF atirador/atleta</Text>
                        </View>
                        <View style={[styles.cell, styles.colF, styles.headerGray]}>
                            <Text>Data em que frequentou a entidade</Text>
                        </View>
                    </View>

                    {athletes.map((item: any, index: number) => (
                        <View style={styles.row} key={index} wrap={false}>
                            <View style={[styles.cell, styles.colA]}>
                                <Text>{index + 1}</Text>
                            </View>
                            <View style={[styles.cell, styles.colBC]}>
                                <Text>{item?.athlete?.full_name}</Text>
                            </View>
                            <View style={[styles.cell, styles.colD]}>
                                <Text>{limparTexto(item?.athlete?.cr_number)}</Text>
                            </View>
                            <View style={[styles.cell, styles.colE]}>
                                <Text>{limparTexto(item?.athlete?.cpf)}</Text>
                            </View>
                            <View style={[styles.cell, styles.colF]}>
                                <Text> {item?.capture_timestamp ? new Date(item.capture_timestamp).toLocaleDateString('pt-BR') : ''} </Text>
                            </View>
                        </View>
                    ))}
                </View>

                <View style={styles.footerText}>
                    <Text>
                        A relação acima, oriunda do controle biométrico e facial desta empresa, está sendo encaminhada nos termos do art. 38, § 5º, inciso III, do Decreto nº 11.615/2023.
                    </Text>
                </View>

                <View style={styles.signature}>
                    <Text>{club?.address?.city?.name}-{club?.address?.city?.state?.abbreviation}, {dateMountString(now)}</Text>
                    <Text>  {'\n'}  {'\n'}  {'\n'}  {'\n'}  {'\n'}  </Text>
                    <Text>{club?.president_name}{'\n'}RESPONSÁVEL PELA ENTIDADE DE TIRO</Text>
                </View>

            </Page>
        </Document>
    )
}
